import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

// Language switcher for the mlux app bar. The Google Translate <select> is
// unreliable inside webviews, so we drive translation via Google's `googtrans`
// cookie + reload; the hidden google_translate_element is the engine that reads
// the cookie on load and applies the translation.
const ID = "google_translate_element";

const LANGS = [
  { c: "en", n: "English" },
  { c: "hi", n: "हिन्दी" },
  { c: "mr", n: "मराठी" },
  { c: "gu", n: "ગુજરાતી" },
  { c: "ta", n: "தமிழ்" },
  { c: "te", n: "తెలుగు" },
  { c: "bn", n: "বাংলা" },
  { c: "kn", n: "ಕನ್ನಡ" },
  { c: "pa", n: "ਪੰਜਾਬੀ" },
];

const setGoogTrans = (value) => {
  const host = window.location.hostname;
  const write = (domain) => {
    const d = domain ? `;domain=${domain}` : "";
    // set + (for clearing) expire
    document.cookie = `googtrans=${value};path=/${d}`;
    if (!value) document.cookie = `googtrans=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/${d}`;
  };
  write("");
  write(host);
  const parts = host.split(".");
  if (parts.length > 1) write("." + parts.slice(-2).join("."));
};

const currentLang = () => {
  const m = document.cookie.match(/googtrans=\/[a-z]+\/([a-z]+)/i);
  return m ? m[1] : "en";
};

const TranslateWidget = () => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("en");

  useEffect(() => {
    setActive(currentLang());
    const init = () => {
      const el = document.getElementById(ID);
      if (!el) return false;
      if (el.childElementCount > 0) return true;
      if (window.google && window.google.translate && window.google.translate.TranslateElement) {
        try {
          // eslint-disable-next-line no-new
          new window.google.translate.TranslateElement({ pageLanguage: "en", autoDisplay: false }, ID);
          return true;
        } catch (e) {
          return false;
        }
      }
      return false;
    };
    if (init()) return;
    let n = 0;
    const t = setInterval(() => {
      n += 1;
      if (init() || n > 60) clearInterval(t);
    }, 300);
    return () => clearInterval(t);
  }, []);

  const pick = (lang) => {
    setOpen(false);
    if (lang === "en") setGoogTrans("");
    else setGoogTrans(`/en/${lang}`);
    window.location.reload();
  };

  return (
    <div className="mlux-translate">
      <button type="button" className="mlux-lang-btn" aria-label="Change language" onClick={() => setOpen((o) => !o)}>
        <i className="fas fa-globe"></i>
        <span className="mlux-lang-code">{(active || "en").toUpperCase()}</span>
      </button>
      {open && createPortal(
        <>
          <div className="mlux-lang-backdrop" onClick={() => setOpen(false)} />
          <div className="mlux-lang-menu">
            {LANGS.map((l) => (
              <button key={l.c} type="button" className={active === l.c ? "on" : ""} onClick={() => pick(l.c)}>
                {l.n}
              </button>
            ))}
          </div>
        </>,
        document.body
      )}
      <div id={ID} style={{ display: "none" }}></div>
    </div>
  );
};

export default TranslateWidget;
